import styled from "styled-components";

export const FooterTitle = styled.h5`
  margin: 0;
  font-size: 24px;
  font-weight: 700;
  padding-bottom: 10px;
  margin-bottom: 30px;
  position: relative;
  color: #fff;
  line-height: 1.2;
  &:after,
  &:before {
    content: "";
    position: absolute;
    bottom: 0;
    left: 0;
    height: 4px;
    border-radius: 20px;
    background-color: #fff;
  }
  &:before {
    width: 15px;
  }
  &:after {
    width: 45px;
    left: 20px;
  }
`;

export const FooterLink = styled.p`
  position: relative;
  color: #fff;
  padding: 5px 0 5px 0;
  display: block;
  -webkit-transition: all 0.5s;
  -ms-transition: all 0.5s;
  transition: all 0.5s;
  margin: 0px;
  cursor: pointer;
  &:hover {
    padding: 5px 0 5px 10px;
  }
`;

export const LocationIcon = () => (
  <svg
    width="40px"
    height="45px"
    viewBox="0 0 55 54"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M54.3842 52.0534C54.1842 51.2534 53.9842 50.4534 53.7842 49.5534C51.7842 40.9534 49.8842 32.2534 47.8842 23.6534C47.6842 22.5534 47.4842 22.4534 46.3842 22.4534C43.4842 22.4534 40.4842 22.4534 37.5842 22.4534C36.9842 22.4534 36.8842 22.3534 37.1842 21.8534C37.8842 20.6534 38.5842 19.4534 39.1842 18.1534C40.1842 16.0534 40.8842 13.9534 40.6842 11.5534C40.2842 8.55336 39.0842 5.95336 36.9842 3.95336C34.2842 1.45336 30.9842 0.153358 27.2842 0.553358C22.4842 1.05336 19.1842 3.55336 17.1842 7.85336C15.6842 11.1534 15.8842 14.4534 17.4842 17.7534C18.1842 19.1534 18.8842 20.5534 19.6842 21.9534C19.8842 22.3534 19.7842 22.5534 19.3842 22.5534C19.1842 22.5534 18.9842 22.5534 18.7842 22.5534C15.4842 22.5534 12.1842 22.5534 8.88422 22.5534C7.98422 22.5534 7.78422 22.7534 7.58422 23.5534C7.28422 24.8534 6.98422 26.2534 6.68422 27.5534C4.98422 34.1534 3.48422 40.9534 1.88422 47.6534C1.58422 49.1534 1.18422 50.5534 0.884221 52.0534C0.784221 52.7534 0.984221 53.0534 1.68422 53.0534C1.98422 53.0534 2.28422 53.0534 2.58422 53.0534H52.7842C53.0842 53.0534 53.2842 53.0534 53.5842 53.0534C54.3842 53.0534 54.5842 52.7534 54.3842 52.0534ZM46.8842 24.4534C47.2842 26.1534 47.6842 27.8534 48.0842 29.5534C48.2842 30.6534 48.5842 31.7534 48.7842 32.8534C48.7842 32.9534 48.8842 33.1534 48.8842 33.2534C48.8842 33.3534 48.8842 33.4534 48.7842 33.5534C48.5842 33.6534 48.4842 33.4534 48.3842 33.3534C47.6842 32.7534 46.9842 32.1534 46.2842 31.5534C44.8842 30.4534 43.5842 29.2534 42.1842 28.1534L42.0842 28.0534C41.3842 27.4534 41.3842 27.4534 42.0842 26.9534C43.3842 26.0534 44.6842 25.1534 45.9842 24.2534C46.6842 23.6534 46.6842 23.6534 46.8842 24.4534ZM43.8842 23.7534C43.9842 23.7534 44.0842 23.7534 44.1842 23.8534C44.1842 24.0534 43.9842 24.1534 43.7842 24.2534C42.7842 24.9534 41.7842 25.6534 40.6842 26.4534C40.3842 26.6534 40.0842 26.7534 39.6842 26.7534C37.9842 26.7534 36.3842 26.7534 34.6842 26.7534C34.4842 26.7534 34.2842 26.8534 34.1842 26.5534C34.0842 26.3534 34.2842 26.2534 34.3842 26.0534C34.7842 25.4534 35.2842 24.7534 35.6842 24.1534C35.8842 23.8534 36.0842 23.6534 36.4842 23.6534H43.8842V23.7534ZM37.8842 28.4534C34.5842 30.8534 31.1842 33.1534 27.8842 35.5534C23.3842 38.7534 18.8842 41.9534 14.4842 45.0534C13.8842 45.4534 13.7842 45.4534 13.4842 44.8534C12.1842 42.8534 10.8842 40.9534 9.58422 38.9534C9.48422 38.7534 9.38422 38.5534 9.28422 38.4534C8.88422 37.8534 8.88422 37.7534 9.48422 37.3534C11.4842 35.9534 13.3842 34.5534 15.3842 33.0534C17.5842 31.4534 19.7842 29.8534 21.9842 28.2534C22.2842 28.0534 22.5842 27.8534 22.9842 27.8534C23.4842 27.7534 23.7842 28.0534 23.9842 28.3534C25.1842 29.9534 26.3842 31.4534 27.6842 33.0534C28.1842 33.6534 28.5842 33.6534 29.0842 33.0534C30.2842 31.5534 31.4842 30.0534 32.6842 28.4534C32.9842 28.0534 33.3842 27.8534 33.8842 27.8534C35.1842 27.8534 36.4842 27.8534 37.7842 27.8534C37.9842 27.8534 38.1842 27.7534 38.2842 27.9534C38.2842 28.2534 37.9842 28.3534 37.8842 28.4534ZM19.1842 18.8534C18.4842 17.6534 17.9842 16.3534 17.5842 15.0534C16.6842 11.9534 17.3842 9.05336 19.0842 6.45336C21.0842 3.35336 24.5842 1.55336 28.2842 1.55336C31.2842 1.55336 33.9842 2.65336 36.0842 4.75336C39.0842 7.65336 40.3842 12.1534 38.4842 16.4534C37.0842 19.5534 35.3842 22.3534 33.4842 25.1534C31.9842 27.3534 30.3842 29.4534 28.6842 31.4534C28.2842 31.9534 28.1842 31.9534 27.7842 31.4534C24.6842 27.5534 21.6842 23.3534 19.1842 18.8534ZM9.98422 23.8534C10.0842 23.7534 10.2842 23.7534 10.4842 23.7534C12.0842 23.7534 13.6842 23.7534 15.3842 23.7534C16.9842 23.7534 18.4842 23.7534 20.0842 23.7534C20.5842 23.7534 20.9842 23.9534 21.1842 24.3534C21.4842 24.8534 21.8842 25.4534 22.1842 25.9534C22.3842 26.2534 22.3842 26.5534 22.0842 26.7534C19.9842 28.2534 17.9842 29.7534 15.8842 31.2534C15.5842 31.4534 15.3842 31.4534 15.1842 31.1534C13.4842 28.8534 11.8842 26.6534 10.1842 24.3534C9.98422 24.1534 9.88422 23.9534 9.98422 23.8534ZM5.38422 38.1534C6.28422 34.1534 7.18422 30.0534 8.18422 26.0534C8.28422 25.6534 8.38422 25.2534 8.48422 24.7534C8.48422 24.6534 8.48422 24.4534 8.68422 24.4534C8.78422 24.4534 8.88422 24.5534 8.98422 24.6534C9.58422 25.5534 10.2842 26.3534 10.8842 27.2534C11.9842 28.7534 13.0842 30.2534 14.0842 31.6534C14.1842 31.7534 14.2842 31.9534 14.2842 32.0534C14.2842 32.3534 14.0842 32.4534 13.8842 32.5534C11.8842 34.0534 9.88422 35.4534 7.88422 36.9534C7.18422 37.4534 6.48422 37.9534 5.88422 38.4534C5.78422 38.5534 5.58422 38.7534 5.48422 38.6534C5.18422 38.4534 5.28422 38.2534 5.38422 38.1534ZM3.78422 51.8534C2.08422 51.8534 2.28422 51.9534 2.58422 50.4534C3.28422 47.4534 3.98422 44.4534 4.58422 41.4534C4.68422 40.9534 4.98422 40.5534 5.38422 40.1534C5.98422 39.7534 6.58422 39.2534 7.18422 38.8534C7.48422 38.6534 7.68422 38.6534 7.98422 38.9534C9.48422 41.2534 10.9842 43.5534 12.4842 45.7534C12.6842 46.0534 12.6842 46.2534 12.3842 46.4534C9.98422 48.1534 7.68422 49.8534 5.28422 51.5534C4.78422 51.9534 4.18422 51.8534 3.78422 51.8534ZM16.8842 51.7534C17.1842 51.3534 17.5842 51.1534 17.8842 50.9534C22.0842 47.9534 26.3842 45.0534 30.5842 42.0534C31.0842 41.7534 31.3842 41.7534 31.7842 42.1534C35.3842 45.1534 38.9842 48.1534 42.6842 51.1534C42.8842 51.3534 43.1842 51.5534 43.3842 51.8534H16.8842V51.7534ZM51.5842 51.8534C50.6842 51.8534 49.6842 51.8534 48.7842 51.8534C47.8842 51.8534 47.0842 51.8534 46.1842 51.8534C45.6842 51.8534 45.3842 51.7534 44.9842 51.4534C40.8842 48.0534 36.7842 44.6534 32.6842 41.2534C31.3842 40.1534 31.3842 40.1534 29.9842 41.0534C25.1842 44.3534 20.4842 47.7534 15.6842 51.1534C14.9842 51.6534 14.2842 51.9534 13.3842 51.8534C11.5842 51.7534 9.68422 51.8534 7.88422 51.8534C7.78422 51.8534 7.48422 51.9534 7.48422 51.7534C7.48422 51.5534 7.68422 51.5534 7.78422 51.4534C15.4842 45.9534 23.2842 40.4534 30.9842 34.9534C31.4842 34.5534 31.7842 34.6534 32.2842 35.0534C37.2842 39.2534 42.3842 43.5534 47.3842 47.7534C48.8842 48.9534 50.3842 50.2534 51.7842 51.5534C51.8842 51.6534 52.0842 51.7534 51.9842 51.8534C51.8842 51.8534 51.6842 51.8534 51.5842 51.8534ZM52.6842 50.4534C52.5842 50.4534 52.4842 50.3534 52.3842 50.2534C51.2842 49.3534 50.0842 48.3534 48.9842 47.4534C45.6842 44.7534 42.4842 41.9534 39.1842 39.2534C37.1842 37.5534 35.0842 35.8534 33.0842 34.1534C32.6842 33.7534 32.6842 33.6534 33.0842 33.2534C35.1842 31.7534 37.1842 30.2534 39.2842 28.8534C40.3842 28.0534 40.3842 28.1534 41.3842 28.9534C43.7842 31.0534 46.2842 33.0534 48.6842 35.1534C49.1842 35.5534 49.4842 35.9534 49.5842 36.6534C50.5842 41.0534 51.5842 45.5534 52.5842 49.9534C52.5842 50.0534 52.5842 50.1534 52.6842 50.2534C52.7842 50.3534 52.7842 50.4534 52.6842 50.4534Z"
      fill="white"
    />
    <path
      d="M34.7842 12.1533C34.7842 15.4533 31.9842 18.2533 28.6842 18.2533C25.2842 18.2533 22.6842 15.5533 22.6842 12.1533C22.6842 8.75333 25.3842 6.15333 28.7842 6.15333C32.0842 6.05333 34.7842 8.75333 34.7842 12.1533Z"
      stroke="white"
      strokeMiterlimit="10"
    />
  </svg>
);

export const ContactInfoIcon = () => (
  <svg
    width="40px"
    height="45px"
    viewBox="0 0 40 53"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M3.42709 1.0835H30.2787C31.6594 1.0835 32.7787 2.20278 32.7787 3.5835V26.3185V49.0535C32.7787 50.4342 31.6594 51.5535 30.2787 51.5535H3.42709C2.04638 51.5535 0.927094 50.4342 0.927094 49.0535V3.5835C0.927094 2.20278 2.04638 1.0835 3.42709 1.0835Z"
      stroke="white"
    />
    <line
      x1="14.8737"
      y1="7.02686"
      x2="21.8563"
      y2="7.02686"
      stroke="white"
      strokeLinecap="round"
    />
    <line
      x1="5.24334"
      y1="16.6465"
      x2="13.8737"
      y2="16.6465"
      stroke="white"
      strokeLinecap="round"
    />
    <line
      x1="5.24334"
      y1="19.8408"
      x2="16.777"
      y2="19.8408"
      stroke="white"
      strokeLinecap="round"
    />
    <line
      x1="5.24334"
      y1="22.7168"
      x2="21.8563"
      y2="22.7168"
      stroke="white"
      strokeLinecap="round"
    />
    <line
      x1="0.927094"
      y1="43.3452"
      x2="32.1213"
      y2="43.3452"
      stroke="white"
      strokeLinecap="round"
    />
    <circle cx="18.9477" cy="47.1944" r="1.67076" fill="white" />
    <rect
      x="25.7831"
      y="15.1797"
      width="13.6764"
      height="9.21478"
      rx="1.5"
      fill="#0082C6"
      stroke="white"
    />
    <path d="M39.3378 15.6443L32.7628 20.3407L26.1877 15.6443" stroke="white" />
    <rect
      x="3.48833"
      y="30.5083"
      width="3.09033"
      height="3.09033"
      fill="white"
    />
    <rect
      x="3.48832"
      y="35.1406"
      width="3.09033"
      height="3.09033"
      fill="white"
    />
    <rect
      x="9.43259"
      y="30.5083"
      width="3.09033"
      height="3.09033"
      fill="white"
    />
    <rect
      x="9.43259"
      y="35.1406"
      width="3.09033"
      height="3.09033"
      fill="white"
    />
    <rect
      x="15.3768"
      y="30.5083"
      width="3.09033"
      height="3.09033"
      fill="white"
    />
    <rect
      x="15.3768"
      y="35.1406"
      width="3.09033"
      height="3.09033"
      fill="white"
    />
    <rect
      x="21.3211"
      y="30.5083"
      width="3.09033"
      height="3.09033"
      fill="white"
    />
    <rect
      x="21.3211"
      y="35.1406"
      width="3.09033"
      height="3.09033"
      fill="white"
    />
    <rect
      x="27.2654"
      y="30.5083"
      width="3.09033"
      height="3.09033"
      fill="white"
    />
    <rect
      x="27.2654"
      y="35.1406"
      width="3.09033"
      height="3.09033"
      fill="white"
    />
  </svg>
);
